<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-body">
        <FooterChangeDate />
        <FooterBreadcrumb />
      </div>
    </div>
    <FooterSocial />
    <FooterGlobal />
    <FooterAudit />
    <FooterDevices />
  </footer>
</template>

<script>
import FooterChangeDate from './FooterChangeDate';
import FooterBreadcrumb from './FooterBreadcrumb';
import FooterSocial from './FooterSocial';
import FooterGlobal from './FooterGlobal';
import FooterAudit from './FooterAudit';
import FooterDevices from './FooterDevices';

export default {
    name: 'Footer',
    components: {
        FooterChangeDate,
        FooterBreadcrumb,
        FooterSocial,
        FooterGlobal,
        FooterAudit,
        FooterDevices,
    },
};
</script>

<style scoped>
.footer {
  font-size: 11pt;
}

.footer-body {
  display: flex;
  justify-content: space-between;
  max-width: 1258px;
  margin: auto;
  padding: 130px 20px 6px 20px;
}

@media (max-width: 910px) {
  .footer-body {
    flex-wrap: wrap;
  }
}
</style>
